import type { PropsWithChildren, ReactNode } from "react";

export interface StatCardContentProps extends PropsWithChildren {
  message: ReactNode;
  className?: string;
}

export function StatCardContent({ message, children, className }: StatCardContentProps) {
  return (
    <div className={className}>
      {typeof children === "string" ? (
        <div className="text-display-small font-semibold text-text-primary">{children}</div>
      ) : (
        children
      )}
      <div className="text-sm leading-4">{message}</div>
    </div>
  );
}
